import { useEffect, useState } from 'preact/hooks';

export default ({ fetchUrls }) => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		const filteredUrls = fetchUrls.filter(url => typeof url === 'string' && url.length > 0);

		if (filteredUrls.length <= 0) {
			return;
		}

		setLoading(true);

		Promise.all(filteredUrls.map(url => fetch(url))).then(responses => Promise.all(responses.map(res => res.json()))).then(data => {
			data.forEach(response => {
				if (response?.success === false) {
					throw new Error(response.data[0].message);
				}
			});
			setData(data);
			setLoading(false);
		}).catch(error => {
			setLoading(false);
			setError(error);
		});
	}, []);

	return [data, { loading, error }];
};
